import request from '@/utils/request'
export function getRelation(empNo) {
	return request({
		url: '/api/employee/' + empNo + '/employee-relation',
		method: 'get',
	})
}
export function getUserInfo(code) {
	return request({
		url: '/api/employee/user-info?code=' + code,
		method: 'get',
	})
}

/**
 * 批量获取人员信息
 * @param codes 人员工号集合
 * @returns {*}
 */
export function getUserInfos(codes) {
	return request({
		url: '/api/employee/user-infos?codes=' + codes.join("&codes="),
		method: 'get',
	})
}

export function getDepartPrincipal(fullName) {
	return request({
		url: 'api/department/depart-principal?fullName=' + fullName,
		method: 'get',
	})
}

export function getAgentInfo(empNo) {
	return request({
		url: '/api/employee/get-agent-info/' + empNo,
		method: 'get',
	})
}

export function getEmpInfo(simpleDtoNoorName) {
	return request({
		url: '/api/Employee/get-emp-info?simpleDtoNoorName=' + simpleDtoNoorName,
		method: 'get',
	})
}
export function getEmpInfoByEmpNo1(empNo) {
	return request({
		url: '/api/Employee/get-emp-info-by-empno1?empNo=' + empNo,
		method: 'get',
	})
}

/**
 * 根据工号判断是否首次入职中原
 * @param empNo
 * @returns {AxiosPromise}
 * @constructor
 */
export function IsFirstInCompany(empNo) {
	return request({
		url: `api/Employee/${empNo}/is-first-in-company`,
		method: 'get'
	})
}

/**
 * 多工号批量判断是否首次入职
 * @param empNos
 * @returns {*}
 * @constructor
 */
export function IsFirstInCompnayForEmpNos(empNos) {
	return request({
		url: `api/Employee/is-first-in-companys?empNos=${empNos.join("&empNos=")}`,
		method: 'get'
	})
}

/**
 * 获取用户信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getUserInformation(data) {
	return request({
		url: `api/Employee/getUserInformation`,
		method: 'post',
		data: data
	})
}